<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Prescription</h5>
        <button type="button" @click="closeModal">X</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <form @submit.prevent="submitHandler">
          <div
            style="background-color: #f0f0f0; padding: 10px; overflow: hidden"
          >
            <button
              style="float: right"
              type="button"
              class="btn btn-success"
              @click="addRow"
            >
              +
            </button>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th width="30%">Drug Name</th>
                <th width="12%">Dosage</th>
                <th width="12%">Frequency</th>
                <th width="12%">Quantity</th>
                <th style="color: red" width="12%">Cost</th>
                <th width="20%">Instruction</th>
                <th width="8%">Remove</th>
                <!-- <th width="6%"></th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="row in prescriptionDetails" :key="row.gen_id">
                <td style="width: 30%">
                  <ItemInput
                    @itemoption-check="setItem"
                    :Rowid="row.gen_id"
                    :Store_id="store_id"
                    :type="'stock'"
                  />
                </td>
                <td style="width: 12%">
                  <input v-model="row.dosage" class="form-control" />
                </td>
                <td style="width: 12%">
                  <input v-model="row.frequency" class="form-control" />
                </td>
                <td style="width: 12%">
                  <input
                    v-model.number="row.quantity"
                    :oninput="getCost(row.quantity, row.gen_id)"
                    type="number"
                    class="form-control"
                  />
                </td>
                <td style="color: red">
                  {{ row.cost }}
                </td>
                <td style="width: 20%">
                  <input v-model="row.instruction" class="form-control" />
                </td>
                <td style="width: 8%">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="removeRow(row.gen_id)"
                  >
                    -
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td
                  style="
                    color: black;
                    font-weight: bold;
                    border-top: 2px solid black;
                  "
                >
                  Sum
                </td>
                <td style="color: red; border-top: 2px solid black">
                  Ksh. {{ total_summation }}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>

          <!-- <div class="form-group">
            <label>Prescription Note</label>
            <textarea v-model="pres_note" class="form-control"></textarea>
          </div> -->

          <div class="d-flex justify-content-end mt-3">
            <button type="submit" class="btn btn-primary">
              Submit Prescription
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "../../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import ItemInput from "../../Inventory/components/iteminput.vue";

export default {
  name: "CreatePrescriptionModal",
  props: {
    visit_id: {
      type: Number,
      required: true,
    },
    pres_type: {
      type: String,
      required: true,
    },
    store_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pres_note: "",
      total_summation: 0,
      loading: false,

      prescriptionDetails: [
        {
          gen_id: 1,
          item_id: null,
          category_id: null,
          frequency: "",
          dosage: "",
          quantity: "",
          cost: "",
          price: "",
          instruction: "",
          is_paid: false,
          is_issued: false,
        },
      ],
    };
  },
  components: {
    ItemInput,
    loader,
  },
  methods: {
    getCost_summation() {
      var totals = 0;
      this.prescriptionDetails.forEach((element) => {
        totals = totals + element.cost;
      });
      this.total_summation = totals;
    },
    getCost(qty, rowId) {
      const target = this.prescriptionDetails.find(
        (row) => row.gen_id === rowId
      );
      if (target) {
        // console.log("========+++========");
        // console.log(item);
        target.cost = qty * target.price;
      }
      this.getCost_summation();
    },
    addRow() {
      const gen_id = Math.floor(Math.random() * 1000000);
      this.prescriptionDetails.push({
        gen_id,
        item_id: null,
        category_id: null,
        frequency: "",
        dosage: "",
        quantity: "",
        cost: "",
        price: "",
        instruction: "",
        is_paid: false,
        is_issued: false,
      });
      this.getCost_summation();
    },

    removeRow(gen_id) {
      this.prescriptionDetails = this.prescriptionDetails.filter(
        (row) => row.gen_id !== gen_id
      );
      this.getCost_summation();
    },

    setItem(item, rowId) {
      const target = this.prescriptionDetails.find(
        (row) => row.gen_id === rowId
      );
      if (target) {
        // console.log("========+++========");
        console.log(item);
        target.item_id = item.id;
        target.price = item.cash_charge;
        // target.cost = item.id;
        target.category_id = item.category_id;
      }
    },

    async submitHandler() {
      this.loading = true;
      const payload = {
        visit_id: this.visit_id,
        company_id: this.company_id,
        pres_type: this.pres_type,
        pres_note: this.pres_note,
        clinic_id: this.clinic_id,
        store_id: this.store_id,
        prescription_details: this.prescriptionDetails.map((item) => ({
          item_id: item.item_id,
          category_id: item.category_id,
          frequency: item.frequency,
          dosage: item.dosage,
          quantity: item.quantity,
          instruction: item.instruction,
          is_paid: item.is_paid,
          is_issued: item.is_issued,
        })),
      };

      await generalApiRequest("create_prescriptions", "POST", payload, 1);
      this.closeModal();
      this.loading = false;
    },

    closeModal() {
      this.$emit("close-add-pres-modal");
    },
  },
};
</script>
